<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0598 6.77665C16.3801 6.7179 16.7131 6.81862 16.9475 7.05302C17.2152 7.32086 17.3085 7.71721 17.1887 8.07645L15.385 13.4876C15.2377 13.9294 14.9897 14.3311 14.6604 14.6604C14.3722 14.9487 14.0281 15.1738 13.6506 15.3245L13.4875 15.385L8.07641 17.1888C7.71717 17.3085 7.32081 17.2152 7.05297 16.9475C6.78517 16.6797 6.69205 16.2834 6.81176 15.9241L8.61547 10.513L8.67504 10.3489C8.8257 9.97158 9.05192 9.62828 9.34008 9.34013C9.66943 9.01078 10.0711 8.76279 10.5129 8.61552L15.9241 6.81181L16.0598 6.77665ZM11.1457 10.513H11.1448C10.9977 10.5621 10.8638 10.6445 10.7541 10.7542C10.6445 10.8639 10.562 10.9977 10.5129 11.1448V11.1458L9.34106 14.6585L12.8547 13.4876L12.9621 13.4446C13.0673 13.3955 13.1629 13.3279 13.2454 13.2454C13.3551 13.1356 13.4384 13.0021 13.4875 12.8548L14.6584 9.3411L11.1457 10.513Z"
    />
    <path
      d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
    />
  </svg>
</template>
